import { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { routes } from './routes';
import { useAuthStore } from '@/core/stores/authStore';
import { useThemeStore } from '@/core/stores/themeStore';
import { useEntitlementStore } from '@/core/stores/entitlementStore';
import { usePendingTaskStore } from '@/core/stores/pendingTaskStore';
import { resumePersistedTasks } from '@/core/services/taskDriver';

export function App() {
  const hydrateAuth = useAuthStore((s) => s.hydrate);
  const authStatus = useAuthStore((s) => s.status);
  const initTheme = useThemeStore((s) => s.init);
  const hydrateEntitlement = useEntitlementStore((s) => s.hydrate);
  const resetEntitlement = useEntitlementStore((s) => s.reset);
  const hydratePendingTasks = usePendingTaskStore((s) => s.hydrate);

  useEffect(() => {
    initTheme();
    void hydrateAuth();
    hydratePendingTasks();
  }, [hydrateAuth, initTheme, hydratePendingTasks]);

  // resume any in-flight task that was persisted across a tab reload.
  // gated on auth so we don't fire requests before the bearer token is ready.
  useEffect(() => {
    if (authStatus === 'authed') resumePersistedTasks();
  }, [authStatus]);

  // 登录态变化驱动权益 hydrate / reset
  useEffect(() => {
    if (authStatus === 'authed') {
      void hydrateEntitlement();
    } else if (authStatus === 'guest') {
      resetEntitlement();
    }
  }, [authStatus, hydrateEntitlement, resetEntitlement]);

  return useRoutes(routes);
}
